import React from "react";
import { Box, Grid, makeStyles } from "@material-ui/core";
import { GRAY_DARKEST } from "../../constants";

const useStyles = makeStyles(() => ({
  titleBar: {
    backgroundColor: GRAY_DARKEST,
    marginBottom: "30px"
  }
}));

interface PageHeaderProps {
  title: string;
  rightContent?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  rightContent
}) => {
  const classes = useStyles();

  return (
    <Grid item xs={12}>
      <Box
        p={4}
        className={classes.titleBar}
        display="flex"
        flexDirection="row"
        alignContent="center"
        justifyContent="space-between"
      >
        <Box fontSize="h4.fontSize" fontWeight="fontWeightBold">
          {title}
        </Box>
        {rightContent}
      </Box>
    </Grid>
  );
};

export default PageHeader;
